(() => {
  const VERSION = '20260830-forcefresh-v15-designer-loader-look';
  if (window.__MF_TASSEN_BOOTSTRAP__ === VERSION) return;
  window.__MF_TASSEN_BOOTSTRAP__ = VERSION;
  document.documentElement.dataset.mfTassenCartBuild = VERSION;

  const current = document.currentScript?.src || '';
  if (!current) { console.error('[MF Tassen-Designer] Bootstrap: Script-URL fehlt.'); return; }
  const assetUrl = filename => { const url = new URL(current, window.location.href); url.pathname = url.pathname.replace(/[^/]+$/, filename); url.search = ''; url.searchParams.set('mfv', VERSION); return url.toString(); };
  const load = (filename, done) => { const script = document.createElement('script'); script.src = assetUrl(filename); script.async = false; script.onload = () => done?.(); script.onerror = () => { console.error('[MF Tassen-Designer] Datei konnte nicht geladen werden:', script.src); done?.(); }; document.head.appendChild(script); };
  window.__MF_TASSEN_LEGACY_CART_LOADING__ = true;
  load('mf-tassen-designer-save-guard-v2.js', () => {
    load('mf-tassen-designer-quantity-v1.js', () => {
      load('mf-emaille-standard-save-v1.js', () => {
        load('mf-tassen-cart-transfer-overlay-direct-v3.js', () => {
          load('mf-tassen-cart-transfer-toplayer-fix-v1.js', () => {
            load('mf-tassen-cart-transfer-ui-designerloader-v1.js', () => {
              const head = document.head; const nativeAppendChild = head.appendChild;
              head.appendChild = function mfFreshAppendChild(node) { try { const src = String(node?.src || ''); if (node?.tagName === 'SCRIPT' && /old-mf-tassen-designer-cart-v5-core\.js(?:\?|$)/.test(src)) { window.__MF_TASSEN_SUPPRESSED_STALE_LOADER__ = true; return node; } } catch (_) {} return nativeAppendChild.call(this,node); };
              load('old-mf-tassen-designer-cart.js', () => { head.appendChild = nativeAppendChild; load('mf-tassen-designer-save-hotfix.js', () => { load('mf-tassen-designer-cart-v5-core.js', () => { window.__MF_TASSEN_RUNTIME_READY__ = VERSION; }); }); });
            });
          });
        });
      });
    });
  });
})();